import { useState } from 'react';
import treatmentReportsService from '../../../services/treatmentReportsService';

export const useReportActions = (report, getFranchiseeId, showNotification) => {
  const [isLoading, setIsLoading] = useState(false);

  // Handle form submission
  const handleSubmit = async (formData, onSave) => {
    if (!formData.customer_id) {
      showNotification('Please select a customer', 'error');
      return;
    }
    
    if (!formData.technician_id) {
      showNotification('Please select a technician', 'error');
      return;
    }

    setIsLoading(true);
    
    try {
      const franchiseeId = getFranchiseeId();
      if (!franchiseeId) return;

      const submitData = {
        ...formData,
        follow_up_date: formData.follow_up_date || null,
        signature_date: formData.signature_date || null
      };

      let result;
      if (report) {
        result = await treatmentReportsService.updateTreatmentReport(franchiseeId, report.id, submitData);
      } else {
        result = await treatmentReportsService.createTreatmentReport(franchiseeId, submitData);
      }

      showNotification(
        report ? 'Treatment report updated successfully' : 'Treatment report created successfully'
      );
      
      onSave(result.report);
    } catch (error) {
      console.error('Error saving treatment report:', error);
      showNotification('Failed to save treatment report', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleSubmit
  };
};